import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import AddLocation from "../Location/AddLocation";
import SideModal from "../SideModal";
import { Save_Locations } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import BasicDetails from "./BasicDetails";
import PropertyInfo from "./PropertyInfo";
import PropertyDetails from "./PropertyDetails";
import { ModalHeader } from "../Styles/InputStyles";

const AddPropertyPage = ({
  setIsAddProperty,
  user,
  getListMutate,
  step,
  setStep,
}) => {
  const dispatch = useDispatch();
  const [stepOneData, setStepOneData] = useState(null);
  const [stepTwoData, setStepTwoData] = useState(null);
  const [stepThreeData, setStepThreeData] = useState(null);
  const [height, setHeight] = useState(window.innerHeight);
  const [showAddLocation, setShowAddLocation] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight); // updates when Safari UI changes
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClose = () => {
    setStep(1);
    setStepOneData(null);
    setStepTwoData(null);
    setIsAddProperty(false);
  };

  //------- Add Location Model -------

  const addLocationFunction = async (payload) => {
    return await axios.post(`${Config.apiUrl}/location/add`, payload, {
      headers: {
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const { isLoading: addLocationLoading, mutate: addLocationMutate } =
    useMutation(addLocationFunction, {
      onSettled: () => {
        setShowAddLocation(false);
      },
      onSuccess: ({ data }) => {
        if (data?.isSuccess === true) {
          toast.success(data?.msg || "Location added successfully");

          if (data?.locations && Array.isArray(data.locations)) {
            const defaultLocations = {
              id: 0,
              name: "All Locations",
              clientId: user.clientId || 0,
            };

            const allLocations = [defaultLocations, ...data.locations];
            dispatch(Save_Locations(allLocations));
          }
        } else {
          toast.error(data?.msg || "An error occurred");
        }
      },

      onError: (error) => {
        toast.error(error?.response?.data?.msg || "An error occurred");
      },
    });
  const handleAddClose = () => {
    setShowAddLocation(false);
  };

  //-----Create Inventory------
  const createInventoryFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/inventory/create`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const createInventorySuccess = (data) => {
    handleClose();

    getListMutate({
      searchQuery: "",
      filterType: "",
    });

    toast.success(data?.data?.msg || "Success");
  };

  const createInventoryError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: createInventoryLoading, mutate: createInventoryMutate } =
    useMutation(createInventoryFunction, {
      onSuccess: createInventorySuccess,
      onError: createInventoryError,
    });

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">Add Inventory</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <div className="px-6 h-full flex flex-col justify-between">
        {step === 1 && (
          <BasicDetails
            onClose={handleClose}
            // user={user}
            // setShowAddLocation={setShowAddLocation}
            stepOneData={stepOneData}
            setStepOneData={setStepOneData}
            setStep={setStep}
            step={step}
          />
        )}
        {step === 2 && (
          <PropertyDetails
            onClose={handleClose}
            setShowAddLocation={setShowAddLocation}
            setStepTwoData={setStepTwoData}
            stepTwoData={stepTwoData}
            step={step}
            setStep={setStep}
          />
        )}
        {step === 3 && (
          <PropertyInfo
            onClose={handleClose}
            setStepThreeData={setStepThreeData}
            stepThreeData={stepThreeData}
            step={step}
            setStep={setStep}
            stepOneData={stepOneData}
            stepTwoData={stepTwoData}
            createInventoryLoading={createInventoryLoading}
            createInventoryMutate={createInventoryMutate}
          />
        )}
      </div>
      <SideModal
        isOpen={showAddLocation}
        onClose={() => setShowAddLocation(false)}
        level="high"
        width="11/12"
      >
        <AddLocation
          setShowAddLocation={setShowAddLocation}
          showAddLocation={showAddLocation}
          addLocationLoading={addLocationLoading}
          addLocationMutate={addLocationMutate}
          handleClose={handleAddClose}
        />
      </SideModal>
    </Container>
  );
};
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
export default AddPropertyPage;
